import React from 'react';
import { Link, Outlet } from 'react-router-dom';
const PAYKIT_ICON = 'https://cdn.magicpatterns.com/uploads/i6gyUzpJZSJ7VugVhRGhrk/paykit-icon.png';
const PAYKIT_LOGO = 'https://cdn.magicpatterns.com/uploads/ahteCuqfRZXgb5T7bgbdNe/paykit-logo.png';
export function MarketingLayout() {
  return <div className="min-h-screen flex flex-col bg-background" data-id="element-257">
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-258">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-259">
          <div className="flex items-center gap-8" data-id="element-260">
            <Link to="/" className="flex items-center gap-2" data-id="element-261">
              <img src={PAYKIT_ICON} alt="PayKit" className="w-8 h-8 rounded-lg" data-id="element-262" />
              <img src={PAYKIT_LOGO} alt="PayKit" className="h-6 hidden sm:block" data-id="element-263" />
            </Link>
            <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-muted-foreground" data-id="element-264">
              <Link to="/#features" className="hover:text-foreground transition-colors" data-id="element-265">
                Features
              </Link>
              <Link to="/pricing" className="hover:text-foreground transition-colors" data-id="element-266">
                Pricing
              </Link>
              <a href="#" className="hover:text-foreground transition-colors" data-id="element-267">
                Docs
              </a>
            </nav>
          </div>
          <div className="flex items-center gap-4" data-id="element-268">
            <Link to="/dashboard" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors hidden sm:block" data-id="element-269">
              Sign In
            </Link>
            <Link to="/setup" className="bg-primary text-primary-foreground hover:opacity-90 px-4 py-2 rounded-md text-sm font-medium transition-opacity" data-id="element-270">
              Start Free Setup
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1" data-id="element-271">
        <Outlet data-id="element-272" />
      </main>

      <footer className="border-t border-border bg-pk-surface py-12" data-id="element-273">
        <div className="container mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-274">
          <div className="col-span-2" data-id="element-275">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-276">
              <img src={PAYKIT_ICON} alt="PayKit" className="w-7 h-7 rounded-md" data-id="element-277" />
              <img src={PAYKIT_LOGO} alt="PayKit" className="h-5" data-id="element-278" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs" data-id="element-279">
              Stripe setup made easy for builders. Launch SaaS payments in
              minutes, not days.
            </p>
          </div>
          <div data-id="element-280">
            <h3 className="font-semibold mb-4" data-id="element-281">Product</h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-282">
              <li data-id="element-283">
                <Link to="/#features" className="hover:text-foreground" data-id="element-284">
                  Features
                </Link>
              </li>
              <li data-id="element-285">
                <Link to="/pricing" className="hover:text-foreground" data-id="element-286">
                  Pricing
                </Link>
              </li>
              <li data-id="element-287">
                <a href="#" className="hover:text-foreground" data-id="element-288">
                  Changelog
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-289">
            <h3 className="font-semibold mb-4" data-id="element-290">Legal</h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-291">
              <li data-id="element-292">
                <a href="#" className="hover:text-foreground" data-id="element-293">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-294">
                <a href="#" className="hover:text-foreground" data-id="element-295">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-296">
                <a href="#" className="hover:text-foreground" data-id="element-297">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="container mx-auto px-4 mt-12 pt-8 border-t border-border text-sm text-muted-foreground flex flex-col md:flex-row justify-between items-center" data-id="element-298">
          <p data-id="element-299">© {new Date().getFullYear()} PayKit. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-300">Not affiliated with Stripe, Inc.</p>
        </div>
      </footer>
    </div>;
}